module.exports = __webpack_public_path__ + "assets/pdf/E06-cn-arup-climate-risk.bd5071ad.pdf";